/* LOVEKULT by J — Theme JS */

// ===== Menu overlay =====
function openMenu() {
  document.getElementById('menuOverlay').classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeMenu(e) {
  if (e && e.target !== e.currentTarget) return;
  document.getElementById('menuOverlay').classList.remove('open');
  document.body.style.overflow = '';
}
document.addEventListener('keydown', e => {
  if (e.key === 'Escape') closeMenu();
});

// ===== Header shrink on scroll =====
function updateHeaderShrink() {
  const header = document.querySelector('header.site-header');
  if (!header) return;
  if (window.scrollY > 80) {
    header.classList.add('shrink');
  } else {
    header.classList.remove('shrink');
  }
}
document.addEventListener('DOMContentLoaded', updateHeaderShrink);
window.addEventListener('scroll', updateHeaderShrink, { passive: true });

// ===== Cart count sync with Shopify AJAX API =====
async function refreshCartCount() {
  try {
    const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    const cart = await res.json();
    const el = document.getElementById('cartCount');
    if (el) el.textContent = cart.item_count > 0 ? cart.item_count : '';
  } catch (err) {
    console.error('Cart fetch failed', err);
  }
}
document.addEventListener('DOMContentLoaded', refreshCartCount);

// ===== Size selection (product page) =====
function initSizeRow() {
  const sizeRow = document.getElementById('sizeRow');
  const variantInput = document.getElementById('selectedVariantId');
  if (!sizeRow || !variantInput) return;

  const buttons = sizeRow.querySelectorAll('button[data-variant-id]');

  buttons.forEach(btn => {
    if (btn.dataset.variantId === variantInput.value && !btn.disabled) {
      btn.classList.add('sel');
    }
  });

  sizeRow.addEventListener('click', e => {
    const btn = e.target.closest('button[data-variant-id]');
    if (!btn || btn.disabled) return;
    buttons.forEach(b => b.classList.remove('sel'));
    btn.classList.add('sel');
    variantInput.value = btn.dataset.variantId;
  });
}
document.addEventListener('DOMContentLoaded', initSizeRow);// ===== Add to cart handler (AJAX) =====
document.addEventListener('click', async e => {
  if (e.target.id === 'addBtn') {
    e.preventDefault();
    const btn = e.target;
    const variantInput = document.getElementById('selectedVariantId');
    const sizeSelected = document.querySelector('#sizeRow button.sel');

    if (!sizeSelected) {
      alert('Please select a size.');
      return;
    }
    if (!variantInput || !variantInput.value) {
      alert('Please select a size.');
      return;
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantInput.value, 10), quantity: 1 })
      });
      if (!res.ok) throw new Error('Add to cart failed');

      btn.textContent = 'Added to Cart ✓';
      btn.style.background = 'var(--accent)';
      refreshCartCount();
      setTimeout(() => {
        btn.textContent = 'Add to Cart';
        btn.style.background = 'var(--black)';
      }, 1800);
    } catch (err) {
      console.error(err);
      alert('Sorry, we could not add this to your cart. Please try again.');
    }
  }
});

// ===== Payment method toggle (cart page) =====
document.addEventListener('change', e => {
  if (e.target.name === 'pay') {
    const visa = document.getElementById('visaFields');
    if (visa) visa.style.display = e.target.value === 'visa' ? 'flex' : 'none';
  }
});
